// "Lloji i punës" i kontratës (kohë e plotë / e pjesshme / …) lexohet nga
// tabela `work_types`. E njëjta tabelë mbushet edhe nga sinkronizimi i lejeve
// me orarin (Vjetor, Mjekësor, …), dhe kur ishte bosh, format binin te
// politikat fiskale — kontrata ofronte "Bruto"/"Neto" si lloj pune.
// Ky helper i mban vetëm llojet e punësimit dhe s'bie kurrë te fiskalet.

export const DEFAULT_WORK_TYPES = [
  { id: 1, name: 'Kohë e plotë' },
  { id: 2, name: 'Kohë e pjesshme' },
];

// Emrat që i fut syncLeaveToSchedule (server.js HOLIDAY_TYPE_NAMES) dhe
// klasifikimet e vjetra të orarit — s'janë lloje kontrate.
const NON_CONTRACT_NAMES = new Set([
  'vjetor', 'mjekësor', 'martesor', 'pa pagesë', 'jashtëzakonshëm', 'me pagesë',
  'dhënie gjaku', 'pushim', 'productive', 'sick leave',
]);

export function workTypeOptions(rows) {
  const seen = new Set();
  const options = (Array.isArray(rows) ? rows : [])
    .map((w) => ({ id: w?.id ?? w?.Id, name: String(w?.name ?? w?.Name ?? '').trim() }))
    .filter((w) => {
      if (w.id === undefined || w.id === null || !w.name) return false;
      const key = w.name.toLowerCase();
      if (NON_CONTRACT_NAMES.has(key) || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  return options.length ? options : DEFAULT_WORK_TYPES;
}

/**
 * Opsioni për vlerën e ruajtur. ID e panjohur (p.sh. 1 = "Vjetor", emër leje i
 * hequr nga lista) jep fushë bosh, jo një emër të shpikur: përdoruesi zgjedh
 * llojin e saktë, dhe ruajtja pa zgjedhje e mban vlerën e vjetër.
 */
export function findWorkType(options, id) {
  if (id === undefined || id === null || id === '') return null;
  return (options || []).find((o) => String(o.id) === String(id)) || null;
}
